import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectIsNavigationVisible = createSelector(
  (state: RootState) => state.layout.isNavigationVisible,
  (isNavigationVisible: boolean) => isNavigationVisible
)

export default selectIsNavigationVisible
